import React from 'react';
import { clsx } from 'clsx';

/**
 * Chevron arrow icon with hover-shift animation.
 *
 * Uses `group/arrow` named group so the hover works independently of any
 * parent `group` wrappers (e.g. on card components). Used by `ArrowLink`,
 * `ArrowExternalLink`, and `ArrowButton`.
 */
export function ArrowIcon({ className }: { className?: string }): React.ReactElement {
  return (
    <svg
      className={clsx(
        'h-4 w-4 transition-transform duration-200 group-hover/arrow:translate-x-0.5',
        className,
      )}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
      aria-hidden="true"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
    </svg>
  );
}
